import classNames from 'classnames';
import React from 'react';
import s from './styles.module.css.json';
/**
 * @example Basic example
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <ButtonGroup>
 *     <ButtonGroupButton>First</ButtonGroupButton>
 *     <ButtonGroupButton selected>Second</ButtonGroupButton>
 *     <ButtonGroupButton>Third</ButtonGroupButton>
 *     <ButtonGroupButton disabled>Fourth</ButtonGroupButton>
 *   </ButtonGroup>
 * </Canvas>;
 * ```
 */
export function Group(_a) {
    var children = _a.children, style = _a.style, className = _a.className;
    return (React.createElement("div", { className: classNames(s['Group'], className), style: style }, children));
}
//# sourceMappingURL=index.js.map